export default "__VITE_ASSET__DqsEdHdG__"